export default "__VITE_ASSET__69237fc3__"